import { notification } from "antd";
import { NotificationPlacement } from "antd/lib/notification";
import ErrorIcon from "../../../assets/icons/discount-circle.svg";
import errorDeduplicationManager from "../../utils/errorDeduplication";

interface ErrorNotificationOptions {
  statusCode?: number;
  endpoint?: string;
  force?: boolean; // Force show notification even if duplicate
}

import COMMON from "../../constants/COMMON";

const ErrorNotification = (
  message: string,
  description?: string,
  options?: ErrorNotificationOptions
) => {
  // Check if we should show this error (deduplication logic)
  const shouldShow =
    options?.force ||
    (!COMMON.IS_ENABLE_DEDUPLICATION_ERROR) ||
    errorDeduplicationManager.shouldShowError(
      message,
      options?.statusCode,
      options?.endpoint
    );

  if (!shouldShow) {
    // Skip duplicate notification
    return;
  }

  const placement: NotificationPlacement = "topRight";
  notification.open({
    duration: 2,
    icon: <img alt="" src={ErrorIcon} style={{ marginBottom: 10 }} />,
    message: message,
    description: description,
    placement,
    style: {
      borderTop: "2px solid #EB4D4D",
    },
  });
};

export default ErrorNotification;
